import { useFragment } from "react-relay";
import { graphql } from "relay-runtime";
import { Decimal, IconDenom } from "rujira.ui";
import { Info } from "rujira.ui/src/components/icons/Icons";
import { PartialWithdrawFragment$key } from "./__generated__/PartialWithdrawFragment.graphql";

const fragment = graphql`
  fragment PartialWithdrawFragment on IndexStatus {
    allocations {
      asset {
        metadata {
          symbol
          decimals
        }
      }
      targetWeight
    }
  }
`;

const TOOLTIP = "Withdraw you underlying assets directly from the vault.";

export const PartialWithdraw = ({
  k,
  rcptAmount,
}: {
  k?: PartialWithdrawFragment$key;
  rcptAmount: bigint;
}) => {
  if (!k) return null;
  const { allocations } = useFragment(fragment, k);
  return (
    <div className="index__partial-grid">
      <div
        className="index__partial-tooltip"
        data-tooltip-content={TOOLTIP}
        data-tooltip-id="global-tip">
        <Info className="w-3" />
      </div>
      {allocations.map((allocation) => (
        <div
          key={allocation.asset.metadata.symbol}
          className="index__partial-item">
          <IconDenom denom={allocation.asset.metadata.symbol} className="w-4" />
          <span className="index__partial-amount">
            <Decimal
              amount={rcptAmount * BigInt(allocation.targetWeight)}
              decimals={allocation.asset.metadata.decimals}
              className="fs-12"
              round={rcptAmount >= 10000000000n ? 3 : 8}
            />
          </span>
        </div>
      ))}
    </div>
  );
};
